<nav  class="nav-bar">
    <a *ngFor="let link of links" 
        [routerLink]="link.url" 
        [routerLinkActiveOptions]="{exact:true}" 
        routerLinkActive="nav-bar__link_active" 
        class="nav-bar__link">
        {{ link.name | translate  }}
    </a>
</nav>